import { render, staticRenderFns } from "./HeaderTopComponent.vue?vue&type=template&id=6befebc0"
import script from "./HeaderTopComponent.vue?vue&type=script&lang=js"
export * from "./HeaderTopComponent.vue?vue&type=script&lang=js"
import style0 from "./HeaderTopComponent.vue?vue&type=style&index=0&id=6befebc0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports